import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modals, ModalsAction, UserSession } from "src/store";
import { ShareInline } from "../share";
import { Report, ReportFill, Share, ShareFill } from "../svg";

export const PlayerActions: React.FC<{ title?: string }> = ({ title }) => {


    //#region dependencies

    const dispatch = useDispatch();
    const modals: Modals = useSelector((state: any) => state.ModalsState);
    const user: UserSession = useSelector((state: any) => state.UserState);

    //#endregion

    //#region states

    const [sharing, setSharing] = useState(false);

    //#endregion

    //#region methods

    const toggleSharing = () => setSharing((x) => !x);

    const showReportModal = () => dispatch(ModalsAction.showReport());

    const showModalSharing = () => dispatch(ModalsAction.showShare());

    //#endregion

    return (
        <>
            <ul className="player-actions d-flex list-unstyled p-0 mb-3 mb-lg-0 rtl">
                <li className="mb-lg-3 position-relative d-none d-lg-block">
                    <button className={`action ${sharing ? "active" : "not-active"}`} onClick={toggleSharing}>
                        <span className="m-auto outline"><Share /></span>
                        <span className="m-auto fill"><ShareFill /></span>
                    </button>
                    {sharing && <ShareInline title={title} />}
                </li>
                {user.loggedIn &&
                    <li className="mb-lg-3">
                        <button className={`action ${modals.report ? "active" : "not-active"}`} onClick={showReportModal}>
                            <span className="m-auto outline"><Report /></span>
                            <span className="m-auto fill"><ReportFill /></span>
                        </button>
                    </li>
                }
            </ul>
            <div className="ml-auto d-block d-lg-none" onClick={showModalSharing}>
                <Share />
            </div>
        </>
    );

};